// Persists the last sign-in method a user picked so the Better Auth login UI
// can surface it (badge + reorder to first) on return. Social providers save
// on click (OAuth redirects us away); email saves after successful sign-in.

const KEY = "b3os-last-signin-method-v1";

export type SignInMethod = "email" | "google" | "github" | "discord" | "microsoft" | "slack";

const VALID: readonly SignInMethod[] = ["email", "google", "github", "discord", "microsoft", "slack"];

export function getLastSignInMethod(): SignInMethod | null {
  if (typeof window === "undefined") return null;
  try {
    const v = window.localStorage.getItem(KEY);
    return v && (VALID as readonly string[]).includes(v) ? (v as SignInMethod) : null;
  } catch {
    return null;
  }
}

export function setLastSignInMethod(method: SignInMethod): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, method);
  } catch {
    // ignore (private mode / quota)
  }
}
